import React, { useContext, useState, useEffect, useRef, useMemo } from "react";
import { TreeSelect, Tag, Avatar, Input } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { AppDataRequired } from "../../App";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTags } from "@fortawesome/free-solid-svg-icons";
import AwsServerService from "../../common/util/AwsServerService";
import _ from "lodash";

const { SHOW_PARENT } = TreeSelect;

const SelectedAvatar = ({ label, value, closable, onClose }) => {
  const getUserThumbnailUrl = (zuid) =>
    `https://contacts.zoho.com/file?ID=${zuid}&fs=thumb`;

  return (
    <Tag
      className="CustomeRoleUserTag"
      closable={closable}
      onClose={onClose}
      icon={
        value ? (
          <img className="Icon" src={getUserThumbnailUrl(value)} alt="User" />
        ) : (
          <UserOutlined className="Icon" />
        )
      }
      style={{ marginInlineEnd: 4, justifyContent: "flex-start", gap: "5px" }}
    >
      {label}
    </Tag>
  );
};

const HierarchicalDropdown = ({ GroupName,styles,filter,handleChangeUser,selectedUsers ,disabledCondition,placeholder,ErrorStatus,clearSearchValue,setclearSearchValue,isMulti, extraStyle, flag, limit,accountClassName, onAddNewContact}) => {
  const [treeData, setTreeData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  //const [selectedUsers, setSelectedUsers] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  // const [zohoUsers, setZohoUsers] = useState([]);
  const zohoUsers = useRef([]);
  // const [roles, setRoles] = useState([]);
  const roles = useRef([]);
  const { AllUsers } = useContext(AppDataRequired);
  const moduleContacts = useSelector((state) => state.AppReduxContext.moduleContacts);
  const AllModuleUsers = useSelector((state) => state.AppReduxContext.AllModuleUsers);
  console.log("selectedUsers",selectedUsers,filter);

  const stableGroupName = useMemo(
    ()=>GroupName,
    [JSON.stringify(GroupName)]
  )
  const wrapTitle = (title, level) => {
  let style = {};
 
  if (level === 1) {
    style = {
      backgroundColor: '#007bff', // Blue background
      color: '#fff',
      fontWeight: 'bold',
      padding: '5px'
    };
  } else if (level === 2) {
    style = {
      backgroundColor: '#5bc0de', // Light blue background
      color: '#fff',
      fontWeight: '500',
      padding: '5px'
    };
  }
 
  return <div style={style}>{title}</div>;
};
 const convertToTreeData = (data) => {
    return new Promise((resolve,reject)=>{
      let tempData = Object.keys(data).map((mainGroup) => {
        if ((GroupName.includes(mainGroup) && GroupName.length !== 1) || GroupName.includes("Deal")) {
          console.log("mainGroup",mainGroup);
          
          return {
            title: mainGroup,
            value: mainGroup,
            selectable:mainGroup== 'Other'?true:false,
            searchTitle: mainGroup,
            children: data[mainGroup].map((subGroup) => ({
              title: subGroup.label,
              value: subGroup.value,
              selectable: mainGroup=='Other'?true:false,
              searchTitle: subGroup.label,
              children: subGroup.Users?.map((user) => ({
                title: user.label,
                value: user.id,
                searchTitle: user.label,
              })) || [],
            })),
          };
        } else if (GroupName.length === 1 && GroupName[0] === mainGroup) {
          return data[mainGroup].map((subGroup) => ({
            title: subGroup.label,
            value: subGroup.value,
            selectable: mainGroup == 'Other' ? true : false,
            searchTitle: subGroup.label,
            children: subGroup.Users?.map((user) => ({
              title: user.label,
              value: user.id,
              searchTitle: user.label,
            })) || [],
            
          }));
        }
        return null;
      }).filter((item) => item !== null).flat();
      resolve(tempData);
    })
  };
  const otherData = () =>{
    const taskGroup = {
    title: wrapTitle("Task", 1),
      value: "Task",
      selectable: false,
      key:"Task",
      children: [
        {
          key:"Assignee",
        title: wrapTitle("Assignee", 2),
        value: "Assignee",
        selectable: true,
        searchTitle: "Assignee"
        }
      ]
    };
    
    const otherGroup = {
    title: wrapTitle("Other", 1),
      key:"Other",
      value: "Other",
      selectable: true,
      children: [
        {
          key:"Everybody else",
          selectable:true,
        title: wrapTitle("Everybody else", 2),
          value: "EverybodyElse",
          searchTitle: "Everybody else"
        }
      ]
    };
    return [taskGroup,otherGroup];    
  }
  const loadDropdownFields = async () => {
     
    let d = [];
    if (GroupName.includes("Role")) {
      await getRoleDropdownData().then(r => {
        d.push(r);
      }).catch(e => {
        console.log(e);
      })
    }
    if (GroupName.includes("Profiles")) {
        await getProfilesDropdownData().then(r => {
          d.push(r);
        }).catch(e => {
          console.log(e);
        })
      }
    if (GroupName.includes("Zoho") || GroupName.includes("Deal")) {
      await getZohoDropdownData().then(r => {
        d.push(r);
      }).catch(e => {
        console.log(e);
      })
    }
    if (GroupName.includes("Teams")) {
      await getTeamsDropdownData().then(r=>{
          d.push(r);  
      }).catch(err=>{
          console.log('failed fetching teams')
      })
    }
    if (GroupName.includes("Task")) {  
        d.push(...otherData()); 
    }
    await getDropdownData().then(r => {
      d = [...d, ...r];
    }).catch(e => {
      console.log(e);
    })
    console.log("data from API",d); 
    setTreeData(d)
  }
  useEffect(()=>{
    loadDropdownFields();
  },[stableGroupName,moduleContacts]);

  useEffect(()=>{
    if(clearSearchValue && searchValue!=""){
      setclearSearchValue(false)
      setSearchValue("")
    }
       
  },[clearSearchValue,searchValue])
  
  const getTeamsDropdownData = () => {
    return new Promise(async (resolve, reject) => { 
      try {
      const res = await AwsServerService.CrudServiceHandler({method:'GET',data:'',route:'TEAMS'});  
            if (res?.data?.length > 0) {
              const teamGroups = res.data.map((team,index) => {
                const members = (team.Members || []).map(member => {
                  let val = zohoUsers.current?.find(usr=>usr.value==member)||(() => {
                    const r = roles.current.find(usr => usr.ROWID == member);
                    return r ? { ...r, searchTitle: `${r.RoleName} (${r.RoleType})` ,roleType: r.RoleType} : null;
                  })() 
                || 'N/A';
                  let label = val?.searchTitle;
                  return {
                  key:`${member}_${index}`,
                  title: (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {label}
                    </div>
                  ),
                  value: `${member}_${index}`,
                  searchTitle: label,
                  roleType: val?.roleType || null,
                  selectable: false,
                }}); 
                return {
                  key:`Team_${team.ROWID}_${team.Team_Name}`,
                  title: team.Team_Name,
                  value: `Team_${team.ROWID}_${team.Team_Name}`,
                  searchTitle: team.Team_Name,
                  selectable: true,
                  children: members,
                };
              });
      
              resolve({
                key:"Teams",
                  title: wrapTitle("Teams", 1),
                value: "Team",
                selectable: false,
                  children: teamGroups.map(team => ({
                    ...team,
                    title: wrapTitle(team.searchTitle, 2),
                    children: team.children
                  })),
                });
            } else {
              resolve({
                key: 'Teams',
                title: "Teams",
                value: "Team",
                selectable: false,
                children: [],
              });
            }
          } catch (error) {
            reject(error);
          } 
    })
  }
  const getRoleDropdownData = () => {
    return new Promise(async (resolve, reject) => {

      const res = await AwsServerService.CrudServiceHandler({
        method: "GET",
        route: "ROLES",
      });
      let dealRoles = {
        title: "Deal Roles",
        searchTitle: "Deal Roles",
        value: "Deal",
        selectable: false,
        children: [],
      }
      let zohoRoles = {
        title: "Internal Roles",
        searchTitle: "Internal Roles",
        value: "Zoho",
        selectable: false,
        children: [],
      }
      let accountRoles = {
        title: "Account Roles",
        searchTitle: "Account Roles",
        value: "Account",
        selectable: false,
        children: [],
      }
      let vendorRoles = {
        title: "Vendor Roles",
        searchTitle: "Vendor Roles",
        value: "Vendor",
        selectable: false,
        children: [],
      }
      if (res.data?.length > 0) {
        // const rolesList = res.data.map((role) => ({
        //   label: role.RoleName,
        //   value: role.ROWID,
        //   icon: <FontAwesomeIcon icon={faTags} />,
        // }));
        
        const rolesList = res.data.map((role) =>{
          if (role.RoleType == "Deal") {
            dealRoles.children.push({
              title: (
                <div style={{ display: "flex", alignItems: "center" }}>
                  {role.RoleName}
                </div>
              ),
              value: role.ROWID,
              roleType:role.RoleType,
              searchTitle: role.RoleName,
            })
          } else if (role.RoleType == "Zoho") {
            zohoRoles.children.push({
              title: (
                <div style={{ display: "flex", alignItems: "center" }}>
                  {role.RoleName}
                </div>
              ),
              value: role.ROWID,
              roleType:role.RoleType,
              searchTitle: role.RoleName,
            })
          }else if (role.RoleType == "Account") {
            accountRoles.children.push({
              title: (
                <div style={{ display: "flex", alignItems: "center" }}>
                  {role.RoleName}
                </div>
              ),
              value: role.ROWID,
              roleType:role.RoleType,
              searchTitle: role.RoleName,
            })
          }else if (role.RoleType == "Vendor") {
            vendorRoles.children.push({
              title: (
                <div style={{ display: "flex", alignItems: "center" }}>
                  {role.RoleName}
                </div>
              ),
              value: role.ROWID,
              roleType:role.RoleType,
              searchTitle: role.RoleName,
            })
          }
        });
        resolve({
  title: wrapTitle("Role", 1),  // Level 1 → Blue
          value: "Role",
          selectable: false,
    children: [zohoRoles,accountRoles,dealRoles,vendorRoles],
        });
        // setRoles(rolesList);
        roles.current=res.data
      }
    })
  }

  const getProfilesDropdownData = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await AwsServerService.GetApplicationProfiles();

      if (res?.data?.length > 0) {
        const profileList = res.data.map((profile) => ({
          key: `profile_${profile.ROWID}`,
          title: (
            <div style={{ display: "flex", alignItems: "center" }}>
              {profile.PROFILE_NAME}
            </div>
          ),
          value: `Profile_${profile.ROWID}`,
          searchTitle: profile.PROFILE_NAME,
        }));
          resolve({
            key: "profiles_root",
          title: wrapTitle("Profiles", 1), // ✅ Blue background
            value: "Profiles",
            selectable: false,
            children: profileList,
          });
        } else {
          resolve({
            key: "profiles_root",
          title: wrapTitle("Profiles", 1), // ✅ Blue background
            value: "Profiles",
            selectable: false,
            children: [],
          });
        }

      } catch (error) {
        reject(error);
      }
    });
  };

  const getZohoDropdownData = () => {
    return new Promise(async (resolve, reject) => {
      if (AllUsers?.length > 0) {
        const usersList = AllUsers.map((user) => ({
          title: (
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* <FontAwesomeIcon icon={faTags} style={{ marginRight: 8 }} /> */}
              {SelectedAvatar({ value: user.zuid, label: user.full_name })}
              {/* {user.full_name} */}
            </div>
          ),
          key: "InternalUsers",
          value: user.zuid,
          searchTitle: user.full_name,
        }));
        // setZohoUsers(usersList);
        zohoUsers.current=usersList
        resolve({
        title: wrapTitle("Internal Users", 1), // Level 2 → Light Blue
          value: "zoho_users",
          selectable: false,
        children: usersList.map(user => ({
          ...user,
          title: user.title, // Level 3 → default
        })),
      });
      }
    });
  } 
  
  const getDropdownData = () => {
    return new Promise(async (resolve,reject)=>{
      if (moduleContacts) {
        let ModifiedData = {};
        Object.keys(moduleContacts || {}).forEach((Type) => {
          if(Type=="Internal") return
          ModifiedData[Type] = {};
          (moduleContacts[Type] || []).forEach((subgroupData,index) => {
            
            const subgroupKey =Type=='Other'? index : subgroupData[`${Type}_Name`]?.id;
            const isTypeNamePresent = subgroupData[`${Type}_Name`];
            if (!ModifiedData[Type][subgroupKey]) {
              ModifiedData[Type][subgroupKey] = {
                label: isTypeNamePresent ? subgroupData[`${Type}_Name`]?.name : subgroupData?.Full_Name,
                value: isTypeNamePresent ? subgroupData[`${Type}_Name`]?.id : subgroupData.id,
                Users: isTypeNamePresent ? [] : undefined,
              };
            }
            isTypeNamePresent && ModifiedData[Type][subgroupKey].Users.push({
              label: subgroupData.Full_Name,
              id: subgroupData.id,
            });
          });
          ModifiedData[Type] = Object.values(ModifiedData[Type]);
        });
        console.log("ModifiedData",ModifiedData);
        
        convertToTreeData(ModifiedData).then(r=>{
          // setTreeData((prev)=>[...prev,...r]);
          resolve(r);
        }).catch(e=>{
          console.log(e);
        })
      }
    });
  }
 
  console.log("treeData",treeData);
  const findNodeByValue = (nodes, val) => {
    for (const node of nodes) {
      if (node.value === val) return node;
      if (node.children) {
        const found = findNodeByValue(node.children, val);
        if (found) return found;
      }
    }
    return null;
  }; 
  return (
    <TreeSelect
      rootClassName={accountClassName || "" }
      status={ErrorStatus}
      allowClear
      // showSearch
      multiple={isMulti}
      maxTagCount="responsive"
      maxTagTextLength={22}
      searchValue={searchValue}
      disabled={disabledCondition}
      treeData={treeData}
      value={selectedUsers?selectedUsers:null}
      onChange={(value, option)=>{
        
        if (isMulti && limit && Array.isArray(value) && value.length > 1) {
          value = [value[value.length - 1]];
        }
      if (flag) {
      const parsed = {
        users: [],
        roles: [],
        profiles: []
      };
      value.forEach((val) => {
        const node = findNodeByValue(treeData, val);
        if (!node) return;
        if(node.key && node.key.includes("profile_")) {
          parsed.profiles.push(val);
        }else if(node.key && node.key.includes("InternalUsers")) {
          parsed.users.push(val);
        }else{
          parsed.roles.push(val);
        }
      });
      handleChangeUser(parsed);
    } else {
      handleChangeUser(value, option);
    } 
      }}
      showCheckedStrategy={SHOW_PARENT}
      placeholder={placeholder?placeholder:"Select Users"}
      style={styles?{...styles}:{ width: "100%", height: "100%" }}
      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
      expandedKeys={expandedKeys}
      onTreeExpand={setExpandedKeys}
      dropdownRender={(menu) => (
        <div>
          <Input
            placeholder="Search..."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            autoFocus
            style={{ marginBottom: 8, width: "100%" }}
          />
          {menu}

          {onAddNewContact && (
            <div
              style={{
                padding: "8px",
                cursor: "pointer",
                borderTop: "1px solid #f0f0f0",
                color: "#1890ff",
              }}
              onMouseDown={(e) => e.preventDefault()}
              onClick={onAddNewContact}
            >
              + Add Contact
            </div>
          )}
        </div>
      )}
      tagRender={({ label,value , closable, onClose }) => { 
        const node = findNodeByValue(treeData, value);
        const displayLabel = node?.roleType ? `${_.isObject(label)?label.props.children:label} (${node.roleType})` : label;
        return (
        <Tag closable={closable} onClose={onClose} icon={<UserOutlined />}  style={extraStyle?{margin:2, display : 'flex'}:{ margin: 2 }}>
          {displayLabel}
        </Tag>
      )}}
      treeNodeFilterProp="searchTitle"
    />
  );
};

export default HierarchicalDropdown;
